module.exports = __webpack_public_path__ + "static/assets/c6bc65d31bd1bc02b8738d3b592edb3b.svg";